module.exports = __webpack_public_path__ + "img/logo.409c772c.png";